import axios from 'axios';
import config from './config';

const API_BASE_URL = `${config.API_BASE_URL}/UsersApi`;

export const fetchUsers = async () => {
  const response = await axios.get(API_BASE_URL);
  return response.data;
};

export const fetchUserById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/${id}`);
  return response.data;
};

export const updateUser = async (id, userData) => {
  const response = await axios.put(`${API_BASE_URL}/${id}`, userData);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/${id}`);
  return response.data;
};

export const resetUserPassword = async (id, newPassword) => {
  const response = await axios.put(`${API_BASE_URL}/ResetPassword/${id}`, { NewPassword: newPassword });
  return response.data;
};
